import {getUrlWithVariant, ProductForm} from '@shopify/theme-product-form';
import {formatMoney} from '@shopify/theme-currency';
import * as cart from '@shopify/theme-cart';
import axios from 'axios';
import Swiper from 'swiper';
import "swiper/swiper.scss";

require('fslightbox');

const classes = {
  hide: 'hide',
};

const selectors = {
  submitButton: "[data-submit-button]",
  subscriptionChoice: '[name="subscription_choice"]',
  subscriptionChoiceRadio: '[name="subscription_choice"]:checked',
  preOrderText: "[data-preorder-text]",
  currentVariant: "[data-current-variant]",
  submitButtonText: "[data-submit-button-text]",
  comparePrice: "[data-product-compare-at-price]",
  yourPrice: "[data-product-your-price]",
  comparePriceText: "[data-compare-text]",
  priceWrapper: "[data-price-wrapper]",
  productForm: "[data-product-form]",
  productPrice: "[data-product-price]",
  quantityValue: ".product-form__quantity-selectors__amount",
  quantityDecrementer: ".product-form__quantity-selectors__adjuster.down",
  quantityIncrementer: ".product-form__quantity-selectors__adjuster.up",
  variantSelect: "[data-product-select]",
  hiddenSelect: "#Option1",
  mainImage: ".variant__image__main-img",
  itemCount: ".item-count",
  stickyCart: '[data-module="mobileStickyForm"]',
  stickyCartCurrentVariantTitle: "[data-selected-variant]",
  stickyCartCurrentVariantPrice: "[data-selected-variant-price]",
  stickyCartVariantId: '.mobile-sticky-form__form input[name="id"]',
  emailWhenAvailableBtn: ".email-me-when-available__btn",
  emailWhenAvailableModalContainer: ".email-me-when-available__outer-modal",
  emailWhenAvailableCloseModal: ".email-me-when-available__inner-modal .close-modal",
};


export default () => {

  const nodeSelectors = {
    stickyCart: document.querySelector(selectors.stickyCart),
    stickyCartCurrentVariantTitle: document.querySelector(selectors.stickyCartCurrentVariantTitle),
    stickyCartVariantId: document.querySelectorAll(selectors.stickyCartVariantId),
    stickyCartCurrentVariantPrice: document.querySelectorAll(selectors.stickyCartCurrentVariantPrice),
    yourPrice: document.querySelector(selectors.yourPrice),
    comparePrice: document.querySelector(selectors.comparePrice),
    emailWhenAvailableBtn: document.querySelector(selectors.emailWhenAvailableBtn),
    emailWhenAvailableModalContainer: document.querySelector(selectors.emailWhenAvailableModalContainer),
    emailWhenAvailableCloseModal: document.querySelector(selectors.emailWhenAvailableCloseModal),
  };

  let product
  const productFormElement = document.querySelector(selectors.productForm);
  const variantSelect = productFormElement.querySelector(selectors.variantSelect);
  const submitButton = productFormElement.querySelector(selectors.submitButton);
  const mainImage = document.querySelector(selectors.mainImage);
  const itemCount = document.querySelector(selectors.itemCount);
  const subscriptionChoices = document.querySelectorAll(selectors.subscriptionChoice)
  const quantityDecrementer = document.querySelector(selectors.quantityDecrementer);
  const quantityIncrementer = document.querySelector(selectors.quantityIncrementer);
  let quantityValue = document.querySelector(selectors.quantityValue);

  const getProductJson = async (handle) => {
    return fetch(`/products/${handle}.js`).then((response) => {
      return response.json();
    });
  }

  const amendUrl = (variant) => {
    if (window.history.replaceState) {
      var currentHref = window.location.href
      window.history.replaceState(variant.title, variant.title, `${currentHref.split('?')[0]}?variant=${variant.id}`);
    }
  }

  const getCartState = async (lastItem) => {
    return await cart.getState()
  }

  const onFormOptionChange = (event) => {
    const variant = event.dataset.variant;
    const option_title = event.target.value
    if(variant){
      
      amendUrl(variant)
      renderPrice(variant)
      
      renderImages(variant)
      checkVariantStock(variant)
      if(nodeSelectors.stickyCart){
        for (var i = nodeSelectors.stickyCartVariantId.length - 1; i >= 0; i--) {
          nodeSelectors.stickyCartVariantId[i].value = variant.id;
        }
        nodeSelectors.stickyCartCurrentVariantTitle.innerText = variant.title;
      }
    } else {
      
    }
  }

  const renderImages = (variant) => {
      const swiper = document.querySelector(".product-images__carousel__swiper").swiper;
      const slides = document.querySelectorAll(".js-Swiper_productImages_Slide");

      slides.forEach( slide => {
        const slideVariantID = parseInt(slide.dataset.variantId);
        const slideImageIndex = parseInt(slide.dataset.imageIndex);

        if (variant.id === slideVariantID) {
          swiper.slideTo(slideImageIndex, 250);
        }
      })
    // }
  }

  const checkVariantStock = (variant) => {
    if(variant.inventory_quantity < 1){
      submitButton.innerText = "Out of Stock"
      submitButton.setAttribute('disabled')
    } else {
      submitButton.innerText = "Add to Bag"
      submitButton.removeAttribute('disabled')
    }
  }

  const renderPrice = (variant) => {

    
    const priceWrapperElement = document.querySelector(
      selectors.priceWrapper,
    );

    //priceWrapperElement.classList.toggle(classes.hide, !variant);
    var priceElement = priceWrapperElement.firstElementChild
    var titleElement = priceWrapperElement.lastElementChild

    let isSubscription = false
    let subscriptionSaving = 0
    let checkedRadio = productFormElement.querySelector(selectors.subscriptionChoiceRadio)
    
    if(checkedRadio === null){
      
    } else if (checkedRadio.value === "subscription"){
      isSubscription = true
      subscriptionSaving = variant.price / 100 * 20
    }
    
    if (variant) {
      priceElement.innerText = formatMoney(variant.price - subscriptionSaving, theme.moneyFormat);
      titleElement.innerText = variant.title;

      if(nodeSelectors.yourPrice) {
        
        var discountPercentage = productFormElement.dataset.pl
        if(variant.compare_at_price > variant.price){
          var discountSaving = (variant.compare_at_price / 100) * parseInt(discountPercentage)
          nodeSelectors.yourPrice.innerText = `Your price: ${formatMoney(variant.compare_at_price - discountSaving, theme.moneyFormat).replace('.00','')}`;
        } else {
          var discountSaving = (variant.price / 100) * parseInt(discountPercentage)
          nodeSelectors.yourPrice.innerText = `Your price: ${formatMoney(variant.price - discountSaving, theme.moneyFormat)}`;
        }
      } else {
        if(variant.compare_at_price > variant.price){
          nodeSelectors.comparePrice.innerText = `Was: ${formatMoney(variant.compare_at_price, theme.moneyFormat)}`;
          nodeSelectors.comparePrice.style.display = 'inline-block'
        } else {
          nodeSelectors.comparePrice.style.display = 'none'
        }
      }
    } else {
      let price = parseInt(document.querySelector('[data-lowest-price]').getAttribute('data-lowest-price'))
      let price_varies = document.querySelector('[data-from-price]').getAttribute('data-from-price')
      if (price_varies) {
        priceElement.innerText = "From " + formatMoney(price, theme.moneyFormat).replace('.00','');
      } else {
        priceElement.innerText = formatMoney(price, theme.moneyFormat).replace('.00','');
      }
      
    }
    for (var i = nodeSelectors.stickyCartCurrentVariantPrice.length - 1; i >= 0; i--) {
      nodeSelectors.stickyCartCurrentVariantPrice[i].innerText = formatMoney(variant.price, theme.moneyFormat);
    }
  }

  const addProductToCart = async (id, quantity, properties) => {
    return await cart.addItem(id, { quantity, properties })
  }

  const addSubscriptionProductToCart = async (data) => {
    return await axios.post(`/cart/add.js`, data)
  }

  const updateIcon = async () => {
    let cartState = await getCartState();
    let newCount = parseInt(cartState.item_count)
    itemCount.dataset.itemCount = newCount
    itemCount.innerText = newCount
  }

  const init = async () => {
    handleQuanties()
    timeout();
  }

  const timeout = async () => {
    let productFormEle = document.querySelector(selectors.productForm)
    let discountData = productFormElement.dataset.pl
    
    product = await getProductJson(productFormEle.dataset.productHandle)
    new ProductForm(productFormEle, product, {
      onOptionChange: onFormOptionChange,
    });

    if(subscriptionChoices){
      let productFormFreqHidden = document.querySelector('.product-form__subscription-frequency')
      for (var i = subscriptionChoices.length - 1; i >= 0; i--) {
        subscriptionChoices[i].addEventListener('change', async (e) => {
          var thisInput = e.currentTarget
          var productData = await getProductJson(productFormEle.dataset.productHandle)
          var variantId = parseInt(productFormElement.querySelector('[name="id"]').value)
          var variant = productData.variants.find(variant => variant.id == variantId);
          if(thisInput.value === "subscription"){
            productFormFreqHidden.style.display = 'block';
            var subscriptionSaving = productData.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value
          } else {
            productFormFreqHidden.style.display = 'none';
          }
          renderPrice(variant)
        });
      }
    }

    const fakeSelectButtons = document.querySelectorAll('[data-fake-variant]');
    
    if(fakeSelectButtons){
      for (var i = fakeSelectButtons.length - 1; i >= 0; i--) {
        fakeSelectButtons[i].addEventListener('click', async (e) => {

          e.preventDefault();
          var thisButton = e.currentTarget
          var selectedFakeSelectButton = document.querySelector('.selected[data-fake-variant]');
          if(selectedFakeSelectButton){
            selectedFakeSelectButton.classList.remove('selected')
          }
          var id = thisButton.dataset.variantId
          var title = thisButton.dataset.variantTitle
          thisButton.classList.add('selected')

          var hiddenSelect = document.querySelector(selectors.hiddenSelect)
          hiddenSelect.setAttribute('value', title)
          var hiddenSelectOption = productFormEle.querySelector(`option[value="${title}"]`)
          var hiddenSelectOptionSelected = productFormEle.querySelector(`#Option1 option[selected="selected"]`)
          hiddenSelectOptionSelected.removeAttribute('selected')
          hiddenSelectOption.setAttribute('selected', 'selected')
          hiddenSelect.dispatchEvent(new Event('change'));

          variantSelect.setAttribute('value', id)
          var variantSelectOptionSelected = variantSelect.querySelector(`option[selected="selected"]`)
          variantSelectOptionSelected.removeAttribute('selected')
          var variantSelectOption = variantSelect.querySelector(`option[value="${id}"]`)
          variantSelectOption.setAttribute('selected', 'selected')
          variantSelect.dispatchEvent(new Event('change'));
        });
      };
    }

    const addToCartButtons = productFormElement.querySelectorAll('button[name="add"]');
    
    if(addToCartButtons){
      for (var i = addToCartButtons.length - 1; i >= 0; i--) {
        addToCartButtons[i].addEventListener('click', async (e) => {
          
          e.preventDefault();
          
          var button = e.currentTarget
          let isSubscription = false
          let checkedRadio = productFormElement.querySelector(selectors.subscriptionChoiceRadio)
          
          if(checkedRadio === null){
            
          } else if (checkedRadio.value === "subscription"){
            isSubscription = true
          }
          
          var idElement = productFormElement.querySelector('[name="id"]')
          var quantity = parseInt(quantityValue.value)
            
          var id = parseInt(idElement.selectedOptions[0].value)
          var priceLevelData = document.querySelector('[data-customer-price-level]')
          
          if (isSubscription){
            var frequencyElement = document.querySelector('[name="frequency"]')
            var properties = {
              selling_plan: parseInt(frequencyElement.selectedOptions[0].value),
              _product_id: 1,
              variant_id: id,
            }
            var data = {
              id: id,
              quantity: quantity,
              selling_plan: parseInt(frequencyElement.selectedOptions[0].value),
              properties: properties
            }
            try {
              
              let productResult = await addSubscriptionProductToCart(data)

            } catch(error) {
              var existingMessage = productFormElement.querySelector('.quantity-message-text')
              if(existingMessage !== null){
                existingMessage.remove();
              }
              let pElement = document.createElement('p')
              pElement.classList.add('quantity-message-text')
              pElement.innerText = `All available stock is in your basket`
              button.parentElement.prepend(pElement)
              setTimeout(function() {
                pElement.remove()
              }, 5000);
              return
            }
          } else {
            var selected = product.variants.find(variant => variant.id == id);
            if(selected.compare_at_price > selected.price){
              var diff = selected.compare_at_price - selected.price
              var discountSavingamount = ((selected.compare_at_price / 100) * parseInt(discountData)).toFixed(0) - diff
            } else {
              var discountSavingamount = ((selected.price / 100) * parseInt(discountData)).toFixed(0)
            }
            
            if(discountSavingamount > 0){
              var properties = {
                _price_level_discount: parseInt(discountData),
                _price_level_saving: discountSavingamount < 0 ? 0 : discountSavingamount
              }
            }
            try {
              let productResult = await addProductToCart(id, quantity, properties)
            } catch(error) {
              var existingMessage = productFormElement.querySelector('.quantity-message-text')
              if(existingMessage !== null){
                existingMessage.remove();
              }
              let pElement = document.createElement('p')
              pElement.classList.add('quantity-message-text')
              pElement.innerText = `All available stock is in your basket`
              button.parentElement.prepend(pElement)
              setTimeout(function() {
                pElement.remove()
              }, 5000);
              return
            }
          }          
  
          const anEvent = new Event('addedToCart');
          document.dispatchEvent(anEvent)

          updateIcon();
        });
      }
    }
  }

  const handleQuanties = () => {
    if(!quantityDecrementer || !quantityIncrementer){
      return;
    }
    quantityDecrementer.addEventListener('click', e => {
      e.preventDefault();
      quantityValue.value > 1 ? quantityValue.value-- : console.log('Cannot go below 0') ;
    })
    quantityIncrementer.addEventListener('click', e => {
      e.preventDefault();
      quantityValue.value++;
    })
  }

  function initOutOfStockEmailMe() {

    function hideModal() { nodeSelectors.emailWhenAvailableModalContainer.classList.remove("show-modal") }
    function showModal() { nodeSelectors.emailWhenAvailableModalContainer.classList.add("show-modal") }
    
    nodeSelectors.emailWhenAvailableBtn.addEventListener('click', e => {
      showModal()
    })
    
    nodeSelectors.emailWhenAvailableCloseModal.addEventListener('click', () => {
      hideModal()
    })
    nodeSelectors.emailWhenAvailableModalContainer.addEventListener('click', e => {
      if (e.target === nodeSelectors.emailWhenAvailableModalContainer) {
        hideModal()
      }
    })
  }
    

  window.addEventListener("load", () => {
    initOutOfStockEmailMe();
    let variant = { id: parseInt( document.querySelector("[data-fake-variant].selected").dataset.variantId )};
    renderImages(variant);
  });
  
  return Object.freeze({
    init
  });

}